import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(({ disabled, unclickable }) =>
  css({
    display: 'flex',
    height: 'min-content',
    opacity: disabled ? 0.4 : 1,
    cursor: unclickable ? 'default' : 'pointer',
  }),
);

themeStyles.addBaseStyles('IconWrapper')(({ theme, isActive }) => {
  const iconColor = isActive ? theme.colors.blues[0] : theme.colors.black[0];

  return css({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: 'auto 0',
    color: iconColor,

    '&:focus': {
      outline: `solid 1px ${theme.colors.darkBlue}`,
      outlineOffset: '-1px',
    },
    '&:hover': {
      color: theme.colors.blues[1],
    },
  });
});

themeStyles.addBaseStyles('SaveBuildLabel')(
  css({
    maxWidth: ['100px', 'none', 'none'],
    pl: '6px',
    mt: '3px',
  }),
);

export default themeStyles;
